/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
// @mui
import {
  Stack,
  Button,
  Container,
  Typography,
  Card,
  Box,
  MenuItem,
  Popover,
  IconButton
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import EditPackages from './EditPackages';
import Iconify from '../../ui-component/iconify';
import AddPackages from './AddPackages';
import { getApi, postApi, patchApi } from '../services/api';
import { toast } from 'react-toastify';
import DeletePackage from './DeletePackage';
import { useNavigate } from 'react-router';
import AssignPackageDialog from './AssignPackageDialog'; // Import the new component

// ----------------------------------------------------------------------

const AdminPackages = () => {
  const [openAdd, setOpenAdd] = useState(false);
  const [packageData, setPackageData] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [editData, setEditData] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [rowData, setRowData] = useState();
  const [hotelName, setHotelName] = useState([]);
  const [selectedHotel, setSelectedHotel] = useState('');
  const [openAssignDialog, setOpenAssignDialog] = useState(false); // Dialog state
  const [selectpackageData , setSelectedPackageData] = useState(null)

  const navigate = useNavigate();

  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => setOpenAdd(false);
  const handleOpenDelete = () => setOpenDelete(true);
  const handleCloseDelete = () => {
    setOpenDelete(false);
    handleClose();
  };
  const handleOpenEdit = () => setOpenEdit(true);

  const handleCloseEdit = () => {
    setOpenEdit(false);
    handleClose();
  };

  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setRowData(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const addPackagesData = async (data) => {
    const response = await postApi(`api/packages/add`, data);
    if (response && response.status === 201) {
      getAllPackagesData();
    }
  };

  const getAllPackagesData = async () => {
    try {
      const response = await getApi(`api/packages/getAllPackages`);
      console.log('response for packages ======>', response);

      if (response && response.status === 200) {
        setPackageData(response?.data?.packagesAllData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Edit packages API
  const editPackagesData = async (values) => {
    try {
      const data = values;
      const result = await patchApi(`api/packages/edit/${editData?._id}`, data);

      if (result && result.status === 200) {
        toast.success('Package Modified Successfully');
        getAllPackagesData();
      }
    } catch (error) {
      toast.error('Cannot Modify Package');
    }
  };

  useEffect(() => {
    getAllPackagesData();
  }, []);

  const handleAssignPackagesClick = async (value) => {
    setSelectedPackageData(value)
    setOpenAssignDialog(true); // Open the dialog when the assign button is clicked
    try {
      const response = await getApi(`api/hotel/viewallhotels`);
      console.log('Response showing all hotels:', response);
      const hotelNames = response.data.map((hotel) => hotel);
      setHotelName(hotelNames);
    } catch (error) {
      console.error('Error fetching hotels:', error);
    }
  };

  const columns = [
    {
      field: '_id',
      headerName: 'S.No.',
      flex: 1,
      cellClassName: 'name-column--cell--capitalize',
      valueGetter: (index) => index.api.getRowIndexRelativeToVisibleRows(index.row._id) + 1
    },
    {
      field: 'title',
      headerName: 'Title',
      flex: 1,
      cellClassName: 'name-column--cell name-column--cell--capitalize',
      renderCell: (params) => {
        const handleOpenView = () => {
          navigate(`/dashboard/packages/view/${params.row._id}`);
        };
        return <Box onClick={handleOpenView}>{params.value}</Box>;
      }
    },

    {
      field: 'description',
      headerName: 'Description',
      flex: 1
    },

    {
      field: 'amount',
      headerName: 'Amount',
      flex: 1,
      renderCell: (params) => {
        return <Box> Rs {params.value}</Box>;
      }
    },

    {
      field: 'days',
      headerName: 'Days',
      flex: 1,
      cellClassName: 'name-column--cell--capitalize'
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      renderCell: (params) => {
        const handleEditClick = async (data) => {
          setEditData(data);
          handleOpenEdit();
        };
        const handleDeleteClick = async (id) => {
          setDeleteId(id);
          handleOpenDelete();
        };

        return (
          <>
            <div>
              <IconButton aria-describedby={params?.row._id} variant="contained" onClick={(event) => handleClick(event, params?.row)}>
                <MoreVertIcon />
              </IconButton>
              <Popover
                id={params?.row._id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left'
                }}
              >
                <MenuItem onClick={() => handleEditClick(params?.row)} disableRipple>
                  <EditIcon style={{ marginRight: '8px' }} />
                  Edit
                </MenuItem>
                <MenuItem onClick={() => handleDeleteClick(params?.row._id)} sx={{ color: 'red' }} disableRipple>
                  <DeleteIcon style={{ marginRight: '8px', color: 'red' }} />
                  Delete
                </MenuItem>
                <MenuItem onClick={()=>handleAssignPackagesClick(params.row)} disableRipple>
                  <Iconify icon="eva:plus-fill" style={{ marginRight: '8px' }} />
                  Assign Package
                </MenuItem>
              </Popover>
            </div>
          </>
        );
      }
    }
  ];

  return (
    <>
      <EditPackages open={openEdit} editData={editData} handleClose={handleCloseEdit} editPackagesData={editPackagesData} />
      <AddPackages open={openAdd} handleClose={handleCloseAdd} addPackagesData={addPackagesData} />
      <DeletePackage open={openDelete} handleClose={handleCloseDelete} id={deleteId} getAllPackagesData={getAllPackagesData} />
      <AssignPackageDialog
        open={openAssignDialog}
        handleClose={() => setOpenAssignDialog(false)}
        hotelName={hotelName}
        selectedHotel={selectedHotel}
        setSelectedHotel={setSelectedHotel}
        packageData = {selectpackageData}
      />
      <Container>
        <Stack direction="row" alignItems="center" mb={5} justifyContent="space-between">
          <Typography variant="h4" gutterBottom>
            Admin Packages
          </Typography>
          <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleOpenAdd}>
            New Package
          </Button>
        </Stack>

        <Card>
          <Box height={620}>
            <DataGrid
              rows={packageData}
              columns={columns}
              components={{ Toolbar: GridToolbar }}
              getRowId={(row) => row._id}
            />
          </Box>
        </Card>
      </Container>
    </>
  );
};

export default AdminPackages;
